import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import {MENU} from '../data/menu'
import {CONTENT_SLIDES} from '../data/content_slides'
import {CONTENT_SLIDES_2} from '../data/content_slides_2'

Vue.use(Vuex);

export const store = new Vuex.Store({
	state: {
		// baseURL: 'https://infotexto.com/restapi/v1/',
		baseURL: 'http://localhost/myprojects/infotexto/restapi/v1/',
		menu: MENU,
		content_slides: CONTENT_SLIDES,
		content_slides_2: CONTENT_SLIDES_2,
	},
	getters: {
		getBaseURL: state => {
			return state.baseURL;
		},
		getMenu: state => {
			return state.menu
		},
		getContentSlides: state => {
			return state.content_slides
		},
		getContentSlides2: state => {
			return state.content_slides_2
		},
	},
	mutations: {},
	actions: {
		axiosRemoveFileData({commit, state, dispatch}, data) {
			return axios.delete(state.baseFileURL + 'remove_file.php', data)
				.then(response => {
					return response.data
				})
				.catch(error => {
					return error
				});
		},
		axiosPostFileData({commit, state, dispatch}, data) {
			return axios.post(state.baseURL +  data.dataForm.table + '/', data.data,
				{headers: {'Content-Type': 'multipart/form-data'}})
				.then(response => {
					return response
				})
				.catch(error => {
					return error
				});
		},
		axiosPostData({commit, state, dispatch}, data) {
			return axios.post(state.baseURL + data.table + '/', JSON.stringify(data), {})
				.then(response => {
					return response
				})
				.catch(error => {
					dispatch('changeMessageApp', {
						status: error.response.data.status,
						message: error.response.data.messages,
					})
					return error
				});
		},
		axiosGetAllData({commit, state, dispatch}, data) {
			return axios.get(state.baseURL + data.table + '/', {})
				.then(response => {
					return response.data;
				})
				.catch(error => {
					return error
				});
		},
		axiosGetOneData({commit, state, dispatch}, data) {
			return axios.get(state.baseURL + data.table + '/' + data.table_id)
				.then(response => {
					return response.data;
				})
				.catch(error => {
					return error
				});
		},
		axiosPutData({commit, state, dispatch}, data) {
			return axios.put(state.baseURL + data.table + '/' + data.table_id, JSON.stringify(data), {})
				.then(response => {
					if(response.data.status === 204)
					return response
				})
				.catch(error => {
					return error
				});
		},
		axiosDeleteData({commit, state, dispatch}, data) {
			return axios.delete(state.baseURL + data.table + '/' + data.table_id)
				.then(response => {
					return response
				})
				.catch(error => {
					return error
				});
		},
		axiosGetNumRows({commit, state, dispatch}, data) {
			return axios.get(state.baseURL + 'total_' + data.table)
				.then(response => response.data)
				.catch(error => {
					return error
				})
		},
		axiosGetNumRowsById({commit, state, dispatch}, data) {
			return axios.get(state.baseURL + 'total_' + data.table + '/' + data.id)
				.then(response => response.data)
				.catch(error => {
					return error
				})
		},
		axiosGetPaginatedData({commit, state, dispatch}, data) {
			return axios.get(state.baseURL + 'pagination_' + data.table + '/' + data.pageIdx + '/' + data.pageNum)
				.then(response => {
					return response;
				})
				.catch(error => {
					return error
				});
		},
		axiosGetPaginatedDataById({commit, state, dispatch}, data) {
			return axios.get(state.baseURL + 'pagination_' + data.table + '/' + data.id + '/' + data.pageIdx + '/' + data.pageNum)
				.then(response => {
					return response.data;
				})
				.catch(error => {
					return error
				});
		}
	}
});



// WEBPACK FOOTER //
// ./src/store/index.js